import React from 'react';
import PropTypes from 'prop-types';

const CompanyInformationSection = props => {
  const {children, title} = props
  return (
    <section className="ed-grid row-gap s-gap-1 s-mb-0">
      <h4 className="s-color-text s-mb-0">{title}</h4>
      {children}
    </section>
  );
};

CompanyInformationSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default CompanyInformationSection;
